import { getLanguageStore } from '../utils/storage/language'

const localeLoaders = {
    zh: () => import(/* webpackChunkName: "locale-zh" */ './lan.cn'),
    en: () => import(/* webpackChunkName: "locale-en" */ './lan.en'),
    th: () => import(/* webpackChunkName: "locale-th" */ './lan.tha'),
    in: () => import(/* webpackChunkName: "locale-in" */ './lan.indo'),
    ko: () => import(/* webpackChunkName: "locale-ko" */ './lan.korea'),
    ru: () => import(/* webpackChunkName: "locale-ru" */ './lan.ru'),
    ja: () => import(/* webpackChunkName: "locale-ja" */ './lan.jp'),
    de: () => import(/* webpackChunkName: "locale-de" */ './lan.german'),
    fr: () => import(/* webpackChunkName: "locale-fr" */ './lan.french'),
    it: () => import(/* webpackChunkName: "locale-it" */ './lan.italy'),
    ar: () => import(/* webpackChunkName: "locale-ar" */ './lan.ar.sa'),
    pt: () => import(/* webpackChunkName: "locale-pt" */ './lan.pt_pt'),
    es: () => import(/* webpackChunkName: "locale-es" */ './lan.es_es'),
    nl: () => import(/* webpackChunkName: "locale-nl" */ './lan.nl_nl'),
    el: () => import(/* webpackChunkName: "locale-el" */ './lan.el_gr'),
    hu: () => import(/* webpackChunkName: "locale-hu" */ './lan.hu_hu'),
    sl: () => import(/* webpackChunkName: "locale-sl" */ './lan.sl_si'),
    ro: () => import(/* webpackChunkName: "locale-ro" */ './lan.ro_ro'),
    cs: () => import(/* webpackChunkName: "locale-cs" */ './lan.cs_cz'),
    fi: () => import(/* webpackChunkName: "locale-fi" */ './lan.fi_fi'),
    da: () => import(/* webpackChunkName: "locale-da" */ './lan.da_dk'),
    pl: () => import(/* webpackChunkName: "locale-pl" */ './lan.pl_pl'),
    bg: () => import(/* webpackChunkName: "locale-bg" */ './lan.bg_bg'),
    et: () => import(/* webpackChunkName: "locale-et" */ './lan.et_ee'),
    vi: () => import(/* webpackChunkName: "locale-vi" */ './lan.vi_vn'),
    sv: () => import(/* webpackChunkName: "locale-sv" */ './lan.sv_se'),
    hi: () => import(/* webpackChunkName: "locale-hi" */ './lan.hi_in'),
    he: () => import(/* webpackChunkName: "locale-he" */ './lan.he_il'),
    ms: () => import(/* webpackChunkName: "locale-ms" */ './lan.ms_my'),
    my: () => import(/* webpackChunkName: "locale-my" */ './lan.my_mm'),
}

export const getCurrLang = (lang) => {
    const { language } = navigator
    const storeLan = getLanguageStore()
    const source = lang || storeLan || language || 'en'
    return String(source).substring(0, 2)
}

/** 只加载当前语言包，其余语言留在异步 chunk，切换语言时页面会刷新后再加载 */
export async function loadLocale(lang) {
    const key = getCurrLang(lang)
    const loader = localeLoaders[key] || localeLoaders.en
    const locale = localeLoaders[key] ? key : 'en'
    const mod = await loader()
    return {
        locale,
        messages: mod.default || mod,
    }
}

export async function getCurLocale(lan) {
    const { messages } = await loadLocale(lan)
    return messages
}
